import { Outlet } from 'react-router';
import { Nav } from '../components/Nav/Nav';
import { DashboardLayoutStyled } from './Layout.styled';

const DashboardLayout = ({ children }: any) => {
  return (
    <DashboardLayoutStyled
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{
        duration: 0.2,
      }}
      layout
    >
      <Nav />
      <Outlet />
    </DashboardLayoutStyled>
  );
};

export default DashboardLayout;
